// extracted by mini-css-extract-plugin
module.exports = {"no-companies":"no-companies-3rl2BtrmokCzMeDXdh1Uu2","noCompanies":"no-companies-3rl2BtrmokCzMeDXdh1Uu2","company":"company-_7DJVqjK7TtmaLVILmOpt"};